module.exports = __webpack_public_path__ + "static/media/1.f0f1809c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16106/1.jpg
// module id = 537
// module chunks = 0